import React ,{useState} from "react";
import Nav from "./Nav";
import {useHistory} from "react-router-dom";
import { BiAddToQueue } from "react-icons/bi";
import { FaUserCheck} from "react-icons/fa";
import { RiLockPasswordLine } from "react-icons/ri";

function CodeVerifier (){
    let history = useHistory();
    const [code , setCode] = useState("");
    const [errorMessage , setErrorMessage] = useState("");

    const handleInputChange = (event) =>{
        event.preventDefault()
        setCode(event.target.value);
    }
    const displayBiodata = () => {
        if(code === ""){
            setErrorMessage("Enter a valid Input");
        }
        else{
            setErrorMessage("");
            history.push(`/biodata/${code}`);
        }
    }

    return(
        <div className="service-staff-body">
                <Nav 
                headerText="STAFF" 
                nav1="Service Queue" 
                nav2="Code Verification" 
                path2="/verify" 
                path1="/serviceQueue" 
                icon2={<BiAddToQueue />} 
                icon1={<FaUserCheck />}
            />
                <div className="body">
                    <div >
            <div className="body-inner-wrapper">
            <div className="code-verify-wrapper">
                <div className="header-container">
                    <h2>VERIFY CODE</h2>
                    <hr />
                </div>
                <p className="error">{errorMessage}</p>
                <div className="code-verify-container">
                    <input
                        type= "text"
                        placeholder= "Enter code"
                        maxLength= "30"
                        className ="code"
                        name= "code"
                        onChange={handleInputChange}
                    />
            
                    <button 
                        type="submit" 
                        className="button" 
                        name="submit"
                        onClick={displayBiodata}
                        >
                        Submit   
                    </button>
                </div>
                
                </div>
            </div>
            </div>
        </div>
        </div>
    )
}
export default CodeVerifier;